module.exports = __webpack_public_path__ + "edcff4728f956d5194a03b76a158c834.ttf";